/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LobbyDeleteIdDelete$Params {
  id: string;
}

export function lobbyDeleteIdDelete(http: HttpClient, rootUrl: string, params: LobbyDeleteIdDelete$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, lobbyDeleteIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as ACSStrictHttpResponse<void>;
    })
  );
}

lobbyDeleteIdDelete.PATH = '/Lobby/Delete/{id}';
